import { InferType, object, string } from 'yup'

export interface IParserSchema {
  name: string
}

export const ParserSchema = object<IParserSchema>({
  name: string().required(),
})

export type TParserSchema = InferType<typeof ParserSchema>
